import React from "react";
import "./footer.less";
import logo from "@/assets/img/logo.png";

const Footer: React.FC = () => {
  return (
    <div className="footer">
      <img src={logo} alt="logo" />
      <section className="info">
        <div className="addr">
          住所: 〒104-0061 東京都中央區銀座7-17-18 ジュエル銀座1F
        </div>
        <div>予約電話: 03-6278-8839</div>
      </section>
    </div>
  );
};

export default Footer;
